import Utils from '@/common/utils/util'
import BasketApi from '@/common/api/eshop/shopping/basket'
import PaymentAPI from '@/common/api/eshop/ordering/payments'
import ShippingAPI from '@/common/api/eshop/ordering/shipping'
import store from "@/common/store";

export const state = {
    isLoading: true,
    paymnetMethods: [],
    shippingMethods: [],
    couponCode: null,
    couponRuleName: null,
    id: 0,
    isActive: true,
    isProductPriceIncludeTax: false,
    items: [],
    taxAmount: 0,
    subTotal: 0,
    subTotalWithDiscount: 0,
    orderTotalNoTax: 0,
    orderTotal: 0,
    userId: 0,
    lastAddedItem: null,
    payment: {
        id: null,
        price: 0
    },
    shipping: {
        id: null,
        price: 0
    }
}

export const mutations = {
    SET_SHIPPING_METHODS(state, shippingMethods) {
        state.shippingMethods = shippingMethods
    },
    SET_PAYMENT_METHODS(state, paymentMethods) {
        state.paymnetMethods = paymentMethods
    },
    SET_SHIPPING(state, shippingMethod) {
        state.shipping = shippingMethod
    },
    SET_PAYMENT(state, paymentMethod) {
        state.payment = paymentMethod
    },
    REMOVE_ITEM(state, itemId) {
        state.items = state.items.filter(item => item.id != itemId)
    },
    SET_LAST_ADDED_ITEM(sate, result) {
        sate.lastAddedItem = result;
    },
    SET_BASKET(state, basket) {
        if (basket.hasOwnProperty("id")) {
            Object.keys(basket).forEach((value, index) => {

                // if (value == 'payment') {
                //     state[value] = basket[value].id > 0 ? Object.assign({}, state.paymnetMethods.find(x => x.id == basket[value].id)) : state.payment;
                // } else if (value == 'shipping') {
                //     state[value] = basket[value].id > 0 ? Object.assign({}, state.shippingMethods.find(x => x.id == basket[value].id)) : state.shipping;
                // } else {
                //   
                // }

                state[value] = basket[value];
            })
        }
    },
    SET_QUANTITY(state, { productId, quantity }) {
        var item = state.items.find(x => x.productId == productId);
        if (item) {
            item.quantity = quantity;
        }
    }
}

export const getters = {
    shippingId(state, getters) {
        return state.shipping.id
    },
    paymentId(state, getters) {
        return state.payment.id
    },
    paymentPrice(state, getters) {
        return  state.payment.price
    },
    shippingPrice(state, getters) {
        return  state.shipping.price;
    },
    getBasketItemsCount(state, getters) {
        return state.items
            .map((item) => item.quantity)
            .reduce((acc, value) => acc + value, 0);
    },
    getBasketItems(state, getters) {
        return state.items;
    },
    orderSubTotal(state, getters) {
        return state.subTotal;
    },
    orderTotal(state, getters) {
        return state.orderTotal;
    },
    orderTotalNoTax(state, getters) {
        return state.orderTotalNoTax;
    },
    orderTotalTax(state, getters) {
        return state.taxAmount;
    },
}

export const actions = {
    async init({ commit, state, dispatch }) {

        await BasketApi.getBasket().then(response => {
            commit('SET_BASKET', response.data.result)
        });

        state.isLoading = false;
        
    },
    async trashBasket() {
        return await BasketApi.trashBasket();
    },
    async removeItem({ commit }, { itemId }) {
        return await BasketApi.remove({ itemId }).then(response => {
            commit('REMOVE_ITEM', itemId)
            commit('SET_BASKET', response.data.result)
        });
    },
    async setPayment({ commit, state, dispatch }, paymentMethod) {
        return await BasketApi.setPayment(paymentMethod).then(response => {
            commit('SET_PAYMENT', paymentMethod)
            commit('SET_BASKET', response.data.result)
        });
    },
    async setShipping({ commit, state, dispatch }, shippingMethod) {
        return await BasketApi.setShipping(shippingMethod).then(response => {
            commit('SET_SHIPPING', shippingMethod)
            commit('SET_BASKET', response.data.result)
        });
    },
    async setQuantity({ commit, state, dispatch }, { productId, quantity }) {
        return await BasketApi.setQuantity({ productId, quantity }).then(response => {
            commit('SET_QUANTITY', { productId, quantity })
            commit('SET_BASKET', response.data.result)
        });
    },
    async addItemToBasket({ commit, state, dispatch }, { productId, quantity }) {
        var response = await BasketApi.addToBasket({ productId, quantity });
        commit('SET_LAST_ADDED_ITEM', response.data.result)
        await BasketApi.getBasket().then(response => {
            commit('SET_BASKET', response.data.result)
        });
        return response.data.result;
    },
    async createOrder({ commit, state, dispatch }, orderData) {
        return await BasketApi.createOrder(orderData);
    },
    async loadShippingMethods({ commit, state, dispatch }, force = false) {
        if (force == false && state.shippingMethods.length > 0)
            return;

        return await ShippingAPI.getAll().then(response => {
            commit('SET_SHIPPING_METHODS', response.data.result)
        })
    },
    async loadPaymentMethods({ commit, state, dispatch }, force = false) {
        if (force == false && state.paymnetMethods.length > 0)
            return;

        return await PaymentAPI.getAll().then(response => {
            commit('SET_PAYMENT_METHODS', response.data.result)
        })
    }

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
